import { Component, View } from 'angular2/core';
import { Router, RouterLink } from 'angular2/router';
import { CORE_DIRECTIVES, FORM_DIRECTIVES } from 'angular2/common';
import { Http } from 'angular2/http';
import { UserService } from '../user.service';

let styles   = require('./signup.css');
let template = require('./signup.html');

@Component({
  selector: 'signup'
})
@View({
  directives: [ RouterLink, CORE_DIRECTIVES, FORM_DIRECTIVES ],
  template: template,
  styles: [ styles ]
})
export class Signup {
  constructor(public router: Router, public userSvc: UserService) {
  }

  signup(event, username, password) {
    event.preventDefault();
    this.userSvc.signup({ username, password })
      .subscribe(
        response => {
          this.router.parent.navigateByUrl('/admin/users/login');
        },
        error => {
          alert(error.text());
        }
      );
  }

  login(event) {
    event.preventDefault();
    this.router.parent.navigateByUrl('/admin/users/login');
  }

}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/user/signup/signup.ts
 **/